import { useState } from 'react'

export const useForm = (initialValues, onSubmit, clearError) => {
  const [values, setValues] = useState(initialValues)

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues(prev => ({
      ...prev,
      [name]: value
    }))
    if (clearError) clearError()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(values)
  }

  return { values, handleChange, handleSubmit }
}